import React, { useEffect, useState } from 'react';
import { usePageTitle } from '../hooks/usePageTitle';
import api from '../api';
import { useTheme } from '../contexts/ThemeContext';

const TR = (s: string) =>
  new Date(s).toLocaleDateString('tr-TR', { day: '2-digit', month: 'short', year: 'numeric' });

const DURUM_STILI: Record<string, { bg: string; renk: string; label: string }> = {
  yeni:        { bg: '#F3F4F6', renk: '#6B7280', label: 'Yeni' },
  iletisimde:  { bg: '#FEF3C7', renk: '#D97706', label: 'İletişimde' },
  ilgileniyor: { bg: '#DBEAFE', renk: '#2563EB', label: 'İlgileniyor' },
  deneme:      { bg: '#EDE9FE', renk: '#7C3AED', label: 'Deneme' },
  kayit_oldu:  { bg: '#D1FAE5', renk: '#059669', label: 'Kayıt Oldu' },
  vazgecti:    { bg: '#FEE2E2', renk: '#DC2626', label: 'Vazgeçti' },
};

export default function ReferansYonetim() {
  usePageTitle('Referans Yönetimi');
  const { isDark } = useTheme();
  const card        = isDark ? '#1a1a1a' : 'white';
  const cardAlt     = isDark ? '#1e1e1e' : '#f8f8f8';
  const border      = isDark ? '#2a2a2a' : '#eee';
  const borderSub   = isDark ? '#202020' : '#f0f0f0';
  const textSec     = isDark ? '#999'    : '#888';
  const textMuted   = isDark ? '#666'    : '#aaa';

  const [tab, setTab] = useState<'referanslar' | 'oduller' | 'bekleyen'>('referanslar');
  const [referanslar, setReferanslar] = useState<any[]>([]);
  const [odulTipleri, setOdulTipleri] = useState<any[]>([]);
  const [bekleyen, setBekleyen] = useState<any[]>([]);
  const [yukleniyor, setYukleniyor] = useState(true);
  const [yeniOdul, setYeniOdul] = useState({ ad: '', aciklama: '', ders_hakki_miktari: 0 });
  const [odul_modal, setOdulModal] = useState(false);

  useEffect(() => { yukle(); }, [tab]);

  async function yukle() {
    setYukleniyor(true);
    try {
      if (tab === 'referanslar') {
        const r = await api.get('/api/referans/liste');
        setReferanslar(r.data);
      } else if (tab === 'oduller') {
        const r = await api.get('/api/referans/odulleri');
        setOdulTipleri(r.data);
      } else {
        const r = await api.get('/api/referans/bekleyen-oduller');
        setBekleyen(r.data);
      }
    } catch {}
    setYukleniyor(false);
  }

  async function odulEkle() {
    if (!yeniOdul.ad) return;
    try {
      await api.post('/api/referans/odulleri', { ...yeniOdul, ders_hakki_miktari: yeniOdul.ders_hakki_miktari || 0 });
      setYeniOdul({ ad: '', aciklama: '', ders_hakki_miktari: 0 });
      setOdulModal(false);
      yukle();
    } catch (e: any) { alert(e.response?.data?.hata ?? e.message ?? 'Eklenemedi'); }
  }

  async function odulToggle(id: string, aktif: boolean) {
    try {
      await api.put(`/api/referans/odulleri/${id}`, { aktif: !aktif });
      yukle();
    } catch {}
  }

  async function verildiIsaretle(id: string) {
    try {
      await api.patch(`/api/referans/odul-ver/${id}/verildi`);
      yukle();
    } catch {}
  }

  return (
    <div style={{ padding: '24px 24px 48px' }}>
      <div style={{ marginBottom: 24, display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <div>
          <h1 style={{ fontSize: 22, fontWeight: 700, margin: 0 }}>Referans Yönetimi</h1>
          <div style={{ fontSize: 13, color: textMuted, marginTop: 4 }}>
            Öğrencilerin yönlendirdiği adaylar ve ödül sistemi
          </div>
        </div>
        {tab === 'oduller' && (
          <button onClick={() => setOdulModal(true)} style={{ background: '#534AB7', color: 'white', border: 'none', borderRadius: 8, padding: '8px 16px', cursor: 'pointer', fontWeight: 600 }}>
            + Ödül Tipi Ekle
          </button>
        )}
      </div>

      {/* Tabs */}
      <div style={{ display: 'flex', gap: 4, marginBottom: 20, background: isDark ? '#1c1c1c' : '#f5f5f5', borderRadius: 10, padding: 4, width: 'fit-content' }}>
        {([['referanslar', 'Referanslar'], ['bekleyen', 'Bekleyen Ödüller'], ['oduller', 'Ödül Tipleri']] as const).map(([key, label]) => (
          <button key={key} onClick={() => setTab(key)} style={{
            padding: '7px 16px', borderRadius: 7, border: 'none', cursor: 'pointer', fontWeight: 600, fontSize: 13,
            background: tab === key ? card : 'transparent',
            color: tab === key ? '#534AB7' : textSec,
            boxShadow: tab === key ? '0 1px 4px rgba(0,0,0,.08)' : 'none',
          }}>{label}</button>
        ))}
      </div>

      {yukleniyor ? (
        <div style={{ padding: 40, textAlign: 'center', color: textMuted }}>Yükleniyor...</div>
      ) : tab === 'referanslar' ? (
        <div style={{ background: card, border: `1px solid ${border}`, borderRadius: 12, overflow: 'hidden' }}>
          {referanslar.length === 0 ? (
            <div style={{ padding: 40, textAlign: 'center', color: textMuted }}>Henüz referans yok.</div>
          ) : (
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
              <thead>
                <tr style={{ background: cardAlt, borderBottom: `1px solid ${border}` }}>
                  {['TARİH', 'ADAY', 'TELEFON', 'REFERANS EDEN', 'DURUM', 'ÖDÜL'].map(h => (
                    <th key={h} style={{ padding: '10px 16px', textAlign: 'left', fontWeight: 600, color: textSec, fontSize: 11 }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {referanslar.map((r, i) => {
                  const dur = DURUM_STILI[r.durum] || DURUM_STILI.yeni;
                  return (
                    <tr key={r.id} style={{ borderTop: i > 0 ? `1px solid ${borderSub}` : 'none' }}>
                      <td style={{ padding: '12px 16px', color: textMuted, whiteSpace: 'nowrap' }}>{TR(r.olusturuldu)}</td>
                      <td style={{ padding: '12px 16px', fontWeight: 500 }}>{r.ad} {r.soyad || ''}</td>
                      <td style={{ padding: '12px 16px', color: isDark ? '#999' : '#666' }}>{r.tel}</td>
                      <td style={{ padding: '12px 16px', color: '#534AB7', fontWeight: 500 }}>
                        {r.referans_ogrenci_ad ? `${r.referans_ogrenci_ad} ${r.referans_ogrenci_soyad || ''}`.trim() : '—'}
                      </td>
                      <td style={{ padding: '12px 16px' }}>
                        <span style={{ background: dur.bg, color: dur.renk, borderRadius: 20, padding: '3px 10px', fontSize: 11, fontWeight: 600 }}>
                          {dur.label}
                        </span>
                      </td>
                      <td style={{ padding: '12px 16px' }}>
                        {r.durum === 'kayit_oldu' && Number(r.odul_sayisi) === 0 ? (
                          <OdulVerModal referansCrmId={r.id} onVerildi={yukle} />
                        ) : Number(r.odul_sayisi) > 0 ? (
                          <span style={{ color: '#10B981', fontSize: 12, fontWeight: 600 }}>✓ Verildi</span>
                        ) : '—'}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
        </div>
      ) : tab === 'bekleyen' ? (
        <div style={{ background: card, border: `1px solid ${border}`, borderRadius: 12, overflow: 'hidden' }}>
          {bekleyen.length === 0 ? (
            <div style={{ padding: 40, textAlign: 'center', color: textMuted }}>Bekleyen ödül yok.</div>
          ) : (
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
              <thead>
                <tr style={{ background: cardAlt, borderBottom: `1px solid ${border}` }}>
                  {['TARİH', 'ÖĞRENCİ', 'ÖDÜL', 'REFERANS ADAYI', ''].map(h => (
                    <th key={h} style={{ padding: '10px 16px', textAlign: 'left', fontWeight: 600, color: textSec, fontSize: 11 }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {bekleyen.map((b, i) => (
                  <tr key={b.id} style={{ borderTop: i > 0 ? `1px solid ${borderSub}` : 'none' }}>
                    <td style={{ padding: '12px 16px', color: textMuted, whiteSpace: 'nowrap' }}>{TR(b.olusturuldu)}</td>
                    <td style={{ padding: '12px 16px', fontWeight: 500 }}>{b.ogrenci_ad} {b.ogrenci_soyad || ''}</td>
                    <td style={{ padding: '12px 16px', color: '#534AB7', fontWeight: 500 }}>{b.odul_adi}</td>
                    <td style={{ padding: '12px 16px', color: isDark ? '#999' : '#666' }}>{b.aday_ad ? `${b.aday_ad} ${b.aday_soyad || ''}` : '—'}</td>
                    <td style={{ padding: '12px 16px' }}>
                      <button onClick={() => verildiIsaretle(b.id)} style={{
                        background: '#10B981', color: 'white', border: 'none', borderRadius: 6,
                        padding: '5px 12px', cursor: 'pointer', fontWeight: 600, fontSize: 12,
                      }}>Verildi ✓</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      ) : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))', gap: 12 }}>
          {odulTipleri.length === 0 && (
            <div style={{ color: textMuted, fontSize: 13, padding: 20 }}>Henüz ödül tipi eklenmemiş.</div>
          )}
          {odulTipleri.map(o => (
            <div key={o.id} style={{ background: card, border: `1px solid ${border}`, borderRadius: 12, padding: 18 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                <div style={{ fontWeight: 600, fontSize: 15 }}>🎁 {o.ad}</div>
                <button onClick={() => odulToggle(o.id, o.aktif)} style={{
                  background: o.aktif ? isDark ? 'rgba(16,185,129,0.15)' : '#D1FAE5' : isDark ? '#222' : '#F3F4F6',
                  color: o.aktif ? '#059669' : textSec,
                  border: 'none', borderRadius: 20, padding: '3px 10px', cursor: 'pointer', fontSize: 11, fontWeight: 600,
                }}>{o.aktif ? 'Aktif' : 'Pasif'}</button>
              </div>
              {o.aciklama && <div style={{ fontSize: 12, color: textSec, marginTop: 6 }}>{o.aciklama}</div>}
            </div>
          ))}
        </div>
      )}

      {/* Ödül tipi ekle modal */}
      {odul_modal && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 200 }}
          onClick={e => { if (e.target === e.currentTarget) setOdulModal(false); }}>
          <div style={{ background: card, borderRadius: 12, padding: 24, width: 360 }}>
            <div style={{ fontWeight: 600, fontSize: 15, marginBottom: 16 }}>Yeni Ödül Tipi</div>
            <input value={yeniOdul.ad} onChange={e => setYeniOdul(p => ({ ...p, ad: e.target.value }))}
              placeholder="Ödül adı (örn: 1 Ders Kredisi)" style={inputSt} />
            <input value={yeniOdul.aciklama} onChange={e => setYeniOdul(p => ({ ...p, aciklama: e.target.value }))}
              placeholder="Açıklama (isteğe bağlı)" style={{ ...inputSt, marginTop: 10 }} />
            <div style={{ marginTop: 10 }}>
              <label style={{ fontSize: 12, color: '#888', display: 'block', marginBottom: 4 }}>Otomatik eklenecek ders hakkı sayısı</label>
              <input type="number" min={0} value={yeniOdul.ders_hakki_miktari}
                onChange={e => setYeniOdul(p => ({ ...p, ders_hakki_miktari: parseInt(e.target.value) || 0 }))}
                placeholder="0 = sadece kayıt (otomatik hak eklenmez)" style={inputSt} />
            </div>
            <div style={{ display: 'flex', gap: 8, marginTop: 16 }}>
              <button onClick={() => setOdulModal(false)} style={{ flex: 1, padding: '10px', borderRadius: 8, border: `1px solid ${border}`, background: card, cursor: 'pointer' }}>İptal</button>
              <button onClick={odulEkle} style={{ flex: 1, padding: '10px', borderRadius: 8, border: 'none', background: '#534AB7', color: 'white', fontWeight: 600, cursor: 'pointer' }}>Ekle</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

function OdulVerModal({ referansCrmId, onVerildi }: { referansCrmId: string; onVerildi: () => void }) {
  const { isDark } = useTheme();
  const card   = isDark ? '#1a1a1a' : 'white';
  const border = isDark ? '#2a2a2a' : '#eee';

  const [open, setOpen] = useState(false);
  const [odulId, setOdulId] = useState('');
  const [aktifOduller, setAktifOduller] = useState<any[]>([]);
  const [yukleniyor, setYukleniyor] = useState(false);

  useEffect(() => {
    if (open) {
      api.get('/api/referans/odulleri').then(r => {
        const aktifler = r.data.filter((o: any) => o.aktif);
        setAktifOduller(aktifler);
        if (aktifler.length) setOdulId(aktifler[0].id);
      }).catch(() => {});
    }
  }, [open]);

  async function ver() {
    if (!odulId) return;
    setYukleniyor(true);
    try {
      const r = await api.post('/api/referans/odul-ver', { odul_id: odulId, referans_crm_id: referansCrmId });
      setOpen(false);
      onVerildi();
      if (r.data.ders_hakki_eklendi) {
        alert('Ödül verildi ve ders hakkı öğrencinin aktif dersine otomatik eklendi.');
      } else {
        alert('Ödül kaydedildi. Ders hakkı eklemek için öğrencinin önce aktif bir derse kaydı olmalı.');
      }
    } catch (e: any) { alert(e.response?.data?.hata ?? 'Ödül verilemedi'); }
    finally { setYukleniyor(false); }
  }

  return open ? (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 300 }}
      onClick={e => { if (e.target === e.currentTarget) setOpen(false); }}>
      <div style={{ background: card, borderRadius: 12, padding: 24, width: 360 }}>
        <div style={{ fontWeight: 600, fontSize: 15, marginBottom: 16 }}>Ödül Ver</div>
        {aktifOduller.length === 0 ? (
          <div style={{ color: '#DC2626', fontSize: 13, padding: '12px 0' }}>
            Aktif ödül tipi yok. Önce "Ödül Tipleri" sekmesinden ödül ekleyin.
          </div>
        ) : (
          <select value={odulId} onChange={e => setOdulId(e.target.value)} style={inputSt}>
            {aktifOduller.map((o: any) => <option key={o.id} value={o.id}>{o.ad}</option>)}
          </select>
        )}
        <div style={{ display: 'flex', gap: 8, marginTop: 16 }}>
          <button onClick={() => setOpen(false)} style={{ flex: 1, padding: '10px', borderRadius: 8, border: `1px solid ${border}`, background: card, cursor: 'pointer' }}>İptal</button>
          <button onClick={ver} disabled={!odulId || yukleniyor} style={{ flex: 1, padding: '10px', borderRadius: 8, border: 'none', background: '#534AB7', color: 'white', fontWeight: 600, cursor: odulId ? 'pointer' : 'default', opacity: odulId ? 1 : 0.5 }}>
            {yukleniyor ? 'Kaydediliyor...' : 'Ödül Ver'}
          </button>
        </div>
      </div>
    </div>
  ) : (
    <button onClick={() => setOpen(true)} style={{ background: '#534AB720', color: '#534AB7', border: 'none', borderRadius: 6, padding: '5px 12px', cursor: 'pointer', fontWeight: 600, fontSize: 12 }}>
      Ödül Ver
    </button>
  );
}

const inputSt: React.CSSProperties = {
  width: '100%', padding: '10px 12px', borderRadius: 8, border: '1px solid #eee',
  fontSize: 14, outline: 'none', boxSizing: 'border-box',
};
